/** Actions names */
export const SET_SOUND_EFFECT_TERM = 'SET_SOUND_EFFECT_TERM';
export const SELECT_SOUND_EFFECT_CATEGORY = 'SELECT_SOUND_EFFECT_CATEGORY';
export const CLEAR_SOUND_EFFECT_CATEGORY = 'CLEAR_SOUND_EFFECT_CATEGORY';
export const CLEAR_SOUND_EFFECT_SEARCH = 'CLEAR_SOUND_EFFECT_SEARCH';

/** Actions */

/**
 * Submitted text term of the sound effects search. The search bar owns what is being typed; only a
 * submit reaches the store, which is what the result list queries on.
 */
export function setSoundEffectTerm(term: string) {
  return { type: SET_SOUND_EFFECT_TERM, payload: { term } };
}

/**
 * Active UCS category filter. `id` is a single `ucsCatId` or the comma-separated list of a whole
 * level-1 category; `label` is what the chip in the search bar reads.
 */
export function selectSoundEffectCategory(id: string, label: string) {
  return { type: SELECT_SOUND_EFFECT_CATEGORY, payload: { id, label } };
}

export function clearSoundEffectCategory() {
  return { type: CLEAR_SOUND_EFFECT_CATEGORY };
}

/** Back to the default listing: no term, no category. */
export function clearSoundEffectSearch() {
  return { type: CLEAR_SOUND_EFFECT_SEARCH };
}
